import { SectionTitleAndSubtitle } from "@/components/SectionTitleAndSubtitle";
import { Box, Container } from "@mui/material";
import { TestimonialsSwipper } from "./TestimonialsSwipper";
import { theme } from "@/theme";

export function TestimonialsSection() {
  return (
    <Box sx={{ background: theme.palette.primary.main }}>
      <Container
        sx={{
          paddingY: {
            xs: "20px",
            sm: "50px",
            md: "70px",
          },
          display: "flex",
          flexDirection: "column",
          gap: {
            xs: 3,
            sm: 5,
          },
          maxWidth: 1200,
        }}
      >
        <SectionTitleAndSubtitle title="Depoimentos" subTitle="Clientes felizes, resultados reais." color="white" />

        <TestimonialsSwipper />
      </Container>
    </Box>
  );
}
